import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Popover } from "antd";
import { updateAsset } from "../../Redux/Slices/powerAfrica.slice";
import { POWER_AFRICA_ASSET_STATUS } from "./constants";
import { updateQrCode } from "../../Redux/Slices/qrcode.slice";
import useAssetThreeDotsOptions from "./useAssetThreeDotsOptions";
import { getAssetTypeName } from "./getAssetType";
import getQrCodeType from "./getQrCodeType";
import { ITEM_STATUS } from "../Login/constants";

const ListDropdown = ({ detail }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { threeDotsPopoverId } = useSelector((state) => state.powerAfrica);

  const [open, setOpen] = useState(false);

  const threeDotsOptions = useAssetThreeDotsOptions().filter(
    (item) => item.hasPermission,
  );

  const getOptions = () => {
    let options = threeDotsOptions;

    // if in service, do not show add to service option
    if (detail.status === POWER_AFRICA_ASSET_STATUS.SERVICE) {
      options = options.filter((item) => item.id !== 4);
    }

    // if not in service, do not show check service option
    if (detail.status !== POWER_AFRICA_ASSET_STATUS.SERVICE) {
      options = options.filter((item) => item.id !== 5);
    }

    // if retired, do not show the retire, edit details, add issues, add to service options
    if (detail.isActive === ITEM_STATUS.RETIRED) {
      options = options.filter(
        (item) =>
          item.id !== 8 && item.id !== 1 && item.id !== 2 && item.id !== 4,
      );
    }

    // if active, do not show the un-retire option
    if (detail.isActive === ITEM_STATUS.ACTIVE) {
      options = options.filter((item) => item.id !== 9);
    }

    if (detail.knownIssues.length)
      options = options.filter((item) => item.id !== 2);

    if (!detail.knownIssues.length)
      options = options.filter((item) => item.id !== 3);

    return options;
  };

  const onOptionClick = async (optionId) => {
    dispatch(
      updateAsset({
        key: "currentAsset",
        value: detail,
      }),
    );

    setOpen(false);

    switch (optionId) {
      case 1:
        navigate(`/assets/edit-asset/${detail.id}`);
        break;
      case 2:
        navigate(`/assets/power-africa-known-issue/${detail.registrationNo}`);
        break;
      case 3:
        navigate(`/assets/power-africa-known-issue/${detail.registrationNo}`);
        break;
      case 4:
        navigate(
          `/add-to-service/${getAssetTypeName(+detail.type)}/${
            detail.registrationNo
          }`,
        );
        break;
      case 5:
        navigate("/service");
        break;
      case 6:
        dispatch(
          updateQrCode({
            key: "viewModal",
            value: {
              visible: true,
              data: {
                assetId: detail.registrationNo,
                assetType: getQrCodeType(+detail.type),
                metaData: {
                  powerAfricaAssetId: detail.id,
                },
              },
            },
          }),
        );
        break;
      case 7:
        dispatch(
          updateAsset({
            key: "deletePowerAfricaAssetModal",
            value: true,
          }),
        );
        break;
      case 8:
        dispatch(
          updateAsset({
            key: "retireAssetModal",
            value: true,
          }),
        );

        break;

      case 9:
        dispatch(
          updateAsset({
            key: "unretireAssetModal",
            value: true,
          }),
        );

        break;
      default:
        break;
    }
  };

  const handleOpenChange = (state) => {
    setOpen(state);

    dispatch(
      updateAsset({
        key: "threeDotsPopoverId",
        value: detail.id,
      }),
    );
  };

  // if three dots has no items (depending on the permission) then return empty fragments
  if (!getOptions().length) {
    return <div />;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomLeft"
      open={open && threeDotsPopoverId === detail.id}
      arrow={false}
      onOpenChange={(state) => handleOpenChange(state)}
      content={
        <div
          className="rounded-md bg-background-white py-1"
          style={{
            width: "156px",
            boxShadow: "2px 2px 8px 0px rgba(0, 0, 0, 0.10)",
          }}
        >
          {getOptions().map((option) => (
            <button
              type="button"
              className={`w-full flex items-center gap-x-3 px-3 py-2 group 
              ${
                option.id === 7
                  ? "hover:bg-light-alert-red-hover"
                  : "hover:bg-background"
              }
              `}
              key={option.id}
              onClick={() => onOptionClick(option.id)}
            >
              {option.icon}
              <p
                className={`font-aileron text-xs font-semibold capitalize ${
                  option.id === 7
                    ? "text-alert-red group-hover:text-alert-red-hover"
                    : "text-dark-gray group-hover:text-black"
                }`}
              >
                {option.value}
              </p>
            </button>
          ))}
        </div>
      }
    >
      <div className="cursor-pointer">
        <img src="/assets/icons/trips/more.svg" alt="dropdown" />
      </div>
    </Popover>
  );
};

export default ListDropdown;
